
//export const API_BASE_URL = 'https://localhost:7033';
export const API_BASE_URL = "https://accumulateplatform.com";
export const API_ENDPOINTS = {
  SEARCH_OPEN_NETWORKS: '/api/v1/BusinessNetwork/SearchOpenNetworks',
  SEARCH_OPEN_USERS: '/api/v1/WebUser/SearchOpenUsers',
  FETCH_NETWORK_BY_CODE: '/api/v1/BusinessNetwork/FetchNetworkByCode/',
  FETCH_NETWORK_BY_NAME: '/api/v1/BusinessNetwork/FetchNetworkByName/',
  FETCH_NETWORK_BY_ID: '/api/v1/BusinessNetwork/FetchNetwork/',
  FETCH_NETWORK_BY_SUBDOMAIN: '/api/v1/BusinessNetwork/FetchNetworkBySubdomain/'
};

export const ROUTES = {
  HOME: '/',
  NETWORK_DETAIL: '/network/:id',
  WHITE_LABEL: '/:networkName',
  WHITE_LABEL_USERS: '/:networkName/users'
};
